import { Component, Vue } from "vue-property-decorator";
// import { InSuketStore } from "@/types/common_suket";
import moment from "moment";
import { storePasien } from "@/store/modules/pasien";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

@Component({
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class BaseSuketTabPage extends Vue {
  register: string | number;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  // allowedUnit = ["05", "2C"];
  allowedUnit = [];
  modalTtd = false;

  suketStore;

  suketSvc: CommonSuket;

  suketUrl = process.env.VUE_APP_API_URL + `/suket/${EnSuketCategory.SehatTht}`;

  suketCategory;

  sending = false;

  getSuketPdfUrl(category: string, id: number) {
    return process.env.VUE_APP_API_URL + `/suket/${category}/${id}/pdf`;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(this.suketCategory, this.dataSuket.id)
      : null;
  }

  get fileSuketCategory() {
    return this.suketCategory ? `suket-${EnSuketCategory.Dirawat}` : null;
  }

  get dataSuket() {
    return this.suketStore.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.surat_date).format("DD-MM-YYYY");
  }

  get loadContent(): boolean {
    return this.suketStore.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.creator_user_id;
  }

  get signeeUserId() {
    return this.dataSuket?.signee_user_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return (
      !this.allowedUnit.includes(userModule.user.unit_id) &&
      !this.allowedUnit.includes("*")
    );
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    this.suketSvc.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    this.suketSvc
      .sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
          appModule.addMsgTtd("");
          this.suketStore.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  remove() {
    appModule.setLoading(true);

    this.suketSvc
      .destroy(this.dataSuket?.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);

        this.suketStore.getSuketByRegister(this.register);
      });
  }

  sendToDigiclaim() {
    if (!this.sending) {
      this.sending = true;

      http
        .getData(
          `/pdf-to-digiclaim/${this.fileSuketCategory}/${this.dataSuket.id}`
        )
        .then(resp => {
          appModule.NoticeDelay(resp.data?.message);
        })
        .catch(err => {
          ErrorAlert.showErrorAlert(err);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }
}
